<template>
  <div
      v-if="visible"
      :style="overlayStyle"
      class="custom-tooltip"
  >
    <slot>
      <div></div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    map: { type: Object, required: true },
    position: { type: Object, required: true },
    visible: { type: Boolean, default: true },
  },
  data() {
    return {
      projection: null,
      pane: null,
      overlay: null,
      pixelPosition: { left: 0, top: 0 },
    }
  },
  computed: {
    overlayStyle() {
      return {
        position: 'absolute',
        left: `${this.pixelPosition.left}px`,
        top: `${this.pixelPosition.top}px`,
        zIndex: 1000,
      }
    },
  },
  watch: {
    visible() { this.drawOverlay() },
    position: {
      handler() { this.drawOverlay() },
      deep: true,
    }
  },
  mounted() {
    this.initOverlay();
  },
  beforeDestroy() {
    if (this.overlay) {
      this.overlay.setMap(null);
    }
  },
  methods: {
    initOverlay() {
      const vm = this;
      function CustomOverlay() {}
      CustomOverlay.prototype = new window.google.maps.OverlayView();
      CustomOverlay.prototype.onAdd = function() {
        vm.pane = this.getPanes().overlayMouseTarget;
        if (vm.$el) {
          vm.pane.appendChild(vm.$el);
        }
      };
      CustomOverlay.prototype.draw = function() {
        if (!vm.map || !vm.position) return;
        const proj = this.getProjection();
        if (!proj) return;
        const point = proj.fromLatLngToDivPixel(
            new window.google.maps.LatLng(vm.position.lat, vm.position.lng)
        );
        if (point && vm.$el) {
          vm.pixelPosition = {
            left: point.x,
            top: point.y - 40,
          };
        }
      };
      CustomOverlay.prototype.onRemove = function() {
        if (vm.$el && vm.$el.parentNode) {
          vm.$el.parentNode.removeChild(vm.$el);
        }
      };

      const overlay = new CustomOverlay();
      overlay.setMap(this.map);
      this.overlay = overlay;
    },
    drawOverlay() {
      if (this.overlay) {
        this.overlay.draw();
      }
    },
  },
}
</script>

<style>
.custom-tooltip {
  background: transparent;
  pointer-events: auto;
}
</style>
